<div class="closing-x-wrap">
    <mat-icon class="close-icon" alt="Close dialog" (click)="cancel()"> close </mat-icon>
</div>

<form class="delete-deal-form" [formGroup]="deleteDealForm" (ngSubmit)="deleteDealSubmit(deleteDealForm)">
    <div>
        <h1 mat-dialog-title>
            {{ header }}
        </h1>
        <div mat-dialog-content>
            <p [innerHTML]="message"></p>

            <mat-form-field appearance="fill" class="delete-reason">
                <mat-label>Reason</mat-label>
                <input matInput placeholder="Reason" required formControlName="reason" />
                <mat-error>Reason Required</mat-error>
            </mat-form-field>
        </div>
        <div class="form-footer">
            <section>
                <div class="cancel-button-row">
                    <div class="confirm-actions right-align" mat-dialog-actions>
                        <button mat-button class="secondary" (click)="cancel()">Cancel</button>
                        <button mat-button class="primary" [disabled]="disableDelete" type="submit">Delete</button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</form>
